import { useEffect, useState } from "react";
import api from "@/lib/api";

let cache = null;
let pending = null;
const subscribers = new Set();

function load() {
  if (!pending) {
    pending = api.get("/client-avatars").then(({ data }) => {
      const map = {};
      (data.avatars || []).forEach((a) => {
        if (a.email) map[`e:${a.email.toLowerCase()}`] = a.data;
        if (a.name) map[`n:${a.name.toLowerCase()}`] = a.data;
      });
      cache = map;
      subscribers.forEach((fn) => fn(map));
    }).catch(() => { pending = null; });
  }
  return pending;
}

export function refreshClientAvatars() {
  pending = null;
  return load();
}

function initials(name) {
  const parts = (name || "?").trim().split(/\s+/).filter(Boolean);
  return ((parts[0]?.[0] || "?") + (parts.length > 1 ? parts[parts.length - 1][0] : "")).toUpperCase();
}

function hue(name) {
  let h = 0;
  for (const ch of name || "") h = (h * 31 + ch.charCodeAt(0)) % 360;
  return h;
}

export const ClientAvatar = ({ name, email, className = "h-5 w-5 text-[8px]", testId = "client-avatar" }) => {
  const [map, setMap] = useState(cache);
  useEffect(() => {
    subscribers.add(setMap);
    if (!cache) load();
    return () => { subscribers.delete(setMap); };
  }, []);
  const src = map && ((email && map[`e:${email.toLowerCase()}`]) || (name && map[`n:${name.toLowerCase()}`]));
  if (src) {
    return <img src={src} alt={name || "client"} className={`shrink-0 rounded-full object-cover ${className}`} data-testid={testId} data-avatar="image" />;
  }
  return (
    <span
      className={`inline-flex shrink-0 select-none items-center justify-center rounded-full font-semibold leading-none text-white ${className}`}
      style={{ backgroundColor: `hsl(${hue(name)} 50% 42%)` }}
      data-testid={testId}
      data-avatar="initials"
    >
      {initials(name)}
    </span>
  );
};
